import React from 'react';
import Reveal from './atoms/reveal';

const WORKS = [
  {
    year: '2019',
    title: 'Hack U 2019 OSAKA',
    href: 'https://hacku.yahoo.co.jp/hacku2019osaka/',
    tech: 'Unity',
    description: 'YahooのハッカソンでAR,音声認識を用いたスマホアプリを作成しました。',
  },
  {
    year: '2019',
    title: 'アレクサスキル作成',
    href: 'https://note.com/tiger59/n/n88ce2d98216d?magazine_key=mf16f774e730e',
    tech: 'Node.js',
    description: 'アレクサスキルのハッカソンで優勝しました。',
  },
  {
    year: '2018',
    title: '需要予測AI',
    href: 'https://aibic-spiral.enpit.jp/2018/10/13/aibic-up18/',
    tech: 'Python',
    description: 'スーパーにおいて各商品の需要を予測し自動で発注数を導き出すAIを作成しました。',
  },
  {
    year: '2018',
    title: '漫才ロボット',
    href: 'http://www.nadasemi.ii.konan-u.ac.jp/robot_manzai/',
    tech: 'Python',
    description: '学内のプロジェクトで漫才ロボットの作成の手伝いをしました。',
  },
  {
    year: '2018, 2019',
    title: 'ICPC',
    href: 'https://icpc.baylor.edu/',
    tech: 'Python',
    description: 'プログラミングの世界大会に参加しました。',
  },
  {
    year: '2017',
    title: 'ゲームエンジン',
    href: 'https://github.com/konan-pbl-2017/teamE',
    tech: 'Java',
    description: '研究室で作成しているゲームエンジンを使いゲームを作成しました。',
  },
  {
    year: '2017',
    title: 'Webアプリ',
    href: null,
    tech: 'Python@Flask',
    description: '初めてWebアプリを作成し実際に学内で使用していただきました。',
  },
  {
    year: '2016',
    title: 'ゲーム',
    href: 'game.html',
    tech: 'Processing',
    description: '初めてプログラミングを学習し学内でゲームを作成し優秀作品に選ばれました。',
  },
];

function Works() {
  return (
    <section id="works" className="home-section parallax text-center py-32" data-stellar-background-ratio="0.5">
      <div className="container">
        <Reveal className="section-heading text-center">
          <h2 className="text-4xl text-center font-semibold py-2">Works</h2>
        </Reveal>
      </div>
      <div className="container">
        <div className="chronology overflow-x-auto">
          <table className="table table-hover mx-auto">
            <tbody>
              {WORKS.map((work, i) => (
                // 行がひとつずつ流れ込んでくる
                <Reveal
                  as="tr"
                  key={`${work.year}-${work.title}`}
                  variant="up"
                  delay={Math.min(i, 5) * 80}
                  threshold={0.05}
                >
                  <th scope="row">{work.year}</th>
                  <td>
                    {work.href ? (
                      <a
                        className="nav-underline inline-block"
                        href={work.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {work.title}
                      </a>
                    ) : (
                      work.title
                    )}
                  </td>
                  <td>{work.tech}</td>
                  <td>{work.description}</td>
                </Reveal>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
export default Works;
